import React, { useEffect, useState } from "react";
import {
  Select,
  MenuItem,
  Box,
  Modal,
  Typography,
  Slider,
  Button,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  IconButton,
  useTheme,
} from "@mui/material";

import AudioRecorder from "../../../media/audioWrap/audioWrap";
import { Close } from "@mui/icons-material";
const CustomDropdown = (props) => {
  const { label, isDisabled, schema, id, files, handleChange } = props;
  console.log(schema?.options, "schema in customdropdown");
  const [fontSize, setFontSize] = useState(16);
  const [showModal, setShowModal] = useState(false);
  const [options, setOptions] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedOption, setSelectedOption] = useState(null);

  const handleSliderChange = (event) => {
    setFontSize(event.target.value);
  };

  const modalClose = () => {
    setShowModal(false);
    setFontSize(16); // Reset font size when closing the modal
  };
  const handleLeftButtonClick = () => {
    setFontSize((prevSize) => Math.max(prevSize - 2, 8));
  };

  const handleRightButtonClick = () => {
    setFontSize((prevSize) => Math.min(prevSize + 2, 40));
  };

  const handleDropdownChange = (event) => {
    const selectedQuestion = event.target.value;
    console.log(selectedQuestion);
    const option = options.find(
      (option) => option.question === selectedQuestion
    );
    console.log(option);
    setSelectedOption(option);
    setShowModal(true);
  };

  const handleRecordClick = () => {
    // Logic to handle recording
    console.log("Recording started");
  };

  const handleRedoClick = () => {
    setShowModal(true);
  };

  useEffect(() => {
    if (isMobile) {
      setFontSize(24);
    } else {
      setFontSize(36);
    }
    setOptions(schema?.options);
  }, [schema]);

  return (
    <div>
      <Box>
        <Select
          value={selectedOption ? selectedOption?.question : "selectt"}
          onChange={handleDropdownChange}
          displayEmpty
          fullWidth
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
          }}
        >
          {options.length > 0 &&
            options?.map((option) => (
              <MenuItem key={option.qid} value={option.question}>
                <Typography variant={isMobile ? "subtitle2" : "body1"}>
                  {option.question}
                </Typography>
              </MenuItem>
            ))}
        </Select>
      </Box>

      {selectedOption && (
        <Dialog
          open={showModal}
          maxWidth={isMobile ? "sm" : "md"}
          fullWidth
          PaperProps={{
            sx: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "20px",
              p: isMobile ? "10px" : "20px", // Reduce padding for mobile screens
              backgroundColor: "#FFF",
              borderRadius: "4px",
            },
          }}
        >
          <DialogTitle>
            Q{selectedOption.qid}
            <IconButton
              aria-label="close"
              onClick={modalClose}
              sx={{
                position: "absolute",
                top: "8px",
                right: "8px",
              }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              m: isMobile ? "0px" : "16px",
              p: isMobile ? "10px" : "20px",
              width: "100%",
            }}
          >
            {" "}
            {/* Remove margin for mobile screens */}
            <Typography
              variant="body1"
              style={{
                fontSize: `${fontSize}px`,
                maxHeight: "200px",
                overflowY: "auto",
                marginBottom: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {selectedOption.question}
            </Typography>
            {/* <Slider
      value={fontSize}
      min={12}
      max={60}
      step={2}
      onChange={handleSliderChange}
      sx={{ mt: isMobile ? '10px' : '16px' }} // Reduce margin-top for mobile screens
    /> */}
            <Box
              display="flex"
              width="100%"
              paddingY={"30px"}
              paddingX={"200px"}
            >
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={handleLeftButtonClick}
                style={{
                  fontSize: `${16}px`,
                  width: "50%",
                  background: "#E9EDF1",
                  borderTopRightRadius: "0",
                  borderBottomRightRadius: "0",
                  color: "black",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                A-
              </Button>
              <Button
                size="large"
                variant="contained"
                color="primary"
                onClick={handleRightButtonClick}
                style={{
                  fontSize: `${32}px`,
                  width: "50%",
                  background: "#E9EDF1",
                  borderTopLeftRadius: "0",
                  borderBottomLeftRadius: "0",
                  color: "black",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                A+
              </Button>
            </Box>
            <AudioRecorder
              handleChange={handleChange}
              toggleAudio={modalClose}
            />{" "}
            {/* Reduce margin-top for mobile screens */}
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default CustomDropdown;
